module.exports = __webpack_public_path__ + "static/media/prolink-law-society-logo.191f52af.png";